'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('LibElementCtrl', LibElementCtrl);

  LibElementCtrl.$inject = ['$scope', 'elements', 'constants', '$mdDialog', 'modules', 'errorMessageService',
    'LibElement', 'LibElementTools', 'Labels', 'pveTemplates', 'sgElementHelpers',
    'EditorConfig', 'SgElementDialogService'];

  function LibElementCtrl ($scope, elements, constants, $mdDialog, modules, errorMessageService,
    LibElement, LibElementTools, Labels, pveTemplates, sgElementHelpers, EditorConfig,
    SgElementDialogService) {

    const vm = this;
    vm.constants = constants;
    vm.modules = modules;
    vm.availableSubmodules = [];
    vm.actions = true;
    vm.selectedElement = {};
    vm.LABELS = Labels;
    vm.pveTemplates = pveTemplates;

    const ElementHelper = new sgElementHelpers({constants});
    vm.editorOptions = EditorConfig({contentLanguage: 'nl'}); // FIXME can vm.editorOptions be removed?

    const nopveTemplate = {
      name: vm.LABELS.getLabel('notemplatesavailable'),
      type: 'pvetemplate',
      active: true,
      selected: true,
    };

    vm.pveTemplates.unshift(nopveTemplate);

    function updateElements (updatedElem) {
      vm.elements = updatedElem.map((e) => {
        e.pveTemplateLabel = e.pveTemplates.length === 0 ?  nopveTemplate.name : vm.getPvETemplateLabel(e.pveTemplates);

        if (e.pveTemplates.length === 0 ) {
          e.pveTemplates.push(nopveTemplate);
        }
        return e;
      });

      ElementHelper.filterElements(vm);
      vm.availableSubmodules = ElementHelper.getAvailableSubmodules(vm.modules);
    }

    vm.$onInit = () => {
      updateElements(elements);
    };

    const setSelectedElement = (element) => {
      vm.selectedElement = element;
      vm.filteredElementsIndex = ElementHelper
        .filterElements(vm)
        .findIndex((e) => e._id === element._id);
    };

    vm.openEditElementDialog = function (allDataIndex, id, element) {
      setSelectedElement(element);
      vm.openLibElementDialog(null, 'edit', vm.selectedElement);
    };

    vm.openCopyElementDialog = function (allDataIndex, id) {
      const deepCopiedElement = angular.copy(vm.elements.find((elem) => elem._id === id));
      vm.openLibElementDialog(null, 'copy', deepCopiedElement);
    };

    vm.removeElement = function (allDataIndex, id) {
      const confirmDelete = $mdDialog.confirm()
        .title(Labels.getLabel('deletespecificationtitle'))
        .htmlContent(generateHTMLWarning(id))
        .ariaLabel(Labels.getLabel('areyousuredeletespecification'))
        .ok(Labels.getLabel('delete'))
        .cancel(Labels.getLabel('cancel'));

      $mdDialog.show(confirmDelete).then(
        function () {
          LibElement.remove({id}).$promise.then(function (updatedElements) {
            errorMessageService.showSuccess(Labels.getLabel('deletedspecification'));
            updateElements(updatedElements);
          });
        }, () => {});
    };

    vm.openLibElementDialog = function(ev, action, selectedElement) {

      const options = {};
      if (action === 'create') {
        options['hiddenFields'] = ['inputType'];
      }

      SgElementDialogService.open(ev, action, selectedElement, modules, options)
        .then(updateElements)
        .catch(() => {
          // cancel was clicked, no need to do anything
        });
    };

    vm.nextElement = () => ElementHelper.nextElement.call(ElementHelper, vm, $scope);

    vm.prevElement = () => ElementHelper.prevElement.call(ElementHelper, vm, $scope);

    function submoduleName (id) {
      const submodule = vm.availableSubmodules.find((submod) => submod._id === id);
      return submodule ? submodule.name : '';
    }

    function filterPvETemplates (column, item) {
      if (!column.value) {
        return true;
      } else if (column.value.length === 0) {
        return false;
      }

      return column.value.some((template) => item.pveTemplates.some((t) =>
        t._id === template._id));
    }

    vm.getPvETemplateLabel = (templates) => templates.map((t) => t.name).join(', ');

    vm.columns = [{
      headerTitle: vm.LABELS.getLabel('name') + '/' + vm.LABELS.getLabel('title'),
      displayKey: 'name',
      type: 'string',
      sortable: true,
      thClass: 'sg-mat-table-cell--sg-table-text-filter',
      columnClickHandler: vm.openEditElementDialog,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('label'),
      displayKey: 'label',
      type: 'string',
      sortable: true,
      thClass: 'sg-mat-table-cell--sg-table-text-filter',
      columnClickHandler: vm.openEditElementDialog,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('specificationbuildinglevel'),
      type: 'multiSelect',
      sortable: true,
      filterData: constants.PROJECT_LEVELS,
      displayKey: 'projectLevel',
      displayKeyFn: ElementHelper.constantDisplayName,
      optionValueKey: '_id',
      optionDisplayKey: 'displayName',
      columnClickHandler: vm.openEditElementDialog,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('knowledgedomain'),
      type: 'multiSelect',
      sortable: true,
      filterData: constants.KNOWLEDGE_LEVELS,
      displayKey: 'knowledgeLevel',
      displayKeyFn: ElementHelper.constantDisplayName,
      optionValueKey: '_id',
      optionDisplayKey: 'displayName',
      columnClickHandler: vm.openEditElementDialog,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('module'),
      type: 'multiSelect',
      sortable: true,
      filterData: modules,
      displayKey: 'moduleId',
      displayKeyFn: ElementHelper.getNameById.bind(null, vm.modules),
      preFilterFn: ElementHelper.modulesFiltered.bind(ElementHelper, vm),
      optionValueKey: '_id',
      optionDisplayKey: 'name',
      columnClickHandler: vm.openSidebar,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('submodule'),
      sortable: true,
      filterData: vm.availableSubmodules,
      displayKey: 'submoduleId',
      displayKeyFn: submoduleName,
      optionValueKey: '_id',
      optionDisplayKey: 'name',
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getPlural('linkedtotemplateshort'),
      type: 'multiSelect',
      sortable: true,
      filterData: vm.pveTemplates,
      customFilter: filterPvETemplates,
      template: 'app-legacy/lib_element/element-table-templates/element.pve.template.html',
      optionValueKey: 'name',
      optionDisplayKey: 'name',
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getPlural('option'),
      tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      template: 'app-legacy/lib_element/element-table-templates/element.options.template.html',
      columnFilter: true,
    }];

    vm.columnFilters = {
      enabled: true,
    };

    vm.pagination = {
      resultLimitDropdown: {
        enabled: true,
        limit: [10, 20, 50, 100, 250, 500]
      },
      resultLimit: 10
    };

    const generateHTMLWarning = (id) => {
      const element = vm.elements.find((elem) => elem._id === id);
      if (!element.pveTemplates || element.pveTemplates.length === 0) {
        return '<span></span>';
      }

      const listItems = element.pveTemplates.reduce((acc, item) => acc + `\n<li>${item.name}</li>`, '');

      return `
        <div class="warning element-warning">
          <div class="icon-message">
            <i class="material-icons">report_problem</i>
          </div>
          <div class="message">
            <h5 style="color: red;">
              ${vm.LABELS.getLabelUpperCase('warning')}: \
              ${vm.LABELS.getLabelCapFirstLetter('specificationcoupledtopvetemplates')}
            </h5>
            <p>
              ${vm.LABELS.getLabelCapFirstLetter('specificationcoupledtopvetemplatesexplanation')}
            </p>
          </div>
          <div class="message-info">
            <ul>
              ${listItems}
            </ul>
          </div>
        </div>
      `;
    };
  }
})();
